import {atom} from 'recoil';

export const apiRootState = atom({
  key: 'apiRootState',
  default: null,
});
